/**
 * TODO: İleri zaman için
 * keywords kısımları yani altında bulunanlar için action olabilir action tıklayınca sayfanın olduğu yerde neresi ise bir blur effecti ile gösterilebilir.
 */
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

const PREFIX = {
    JUMP: "jump",
    NEW: "new",
    VISITOR: "visitor",
    DM: "dm",
};

const TYPES = {
    NAVIGATOR: "navigator",
};

module.exports = (that) => {
    const settingPageChange = (name, action) => {
        that.$router.push(`/settings/${name}` + (action ? `?action=${action}` : ""));
        SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.SETTINGS_PAGE_CHANGED, {
            name,
            action,
        });
    };
    const openNotificationSettings = () => {
        SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.NOTIFICATION_SETTINGS);
    };
    return [
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("notifications"),
            name: that.$t("search.allNotificationSettings"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("audit-logs"),
            name: that.$t("search.allAuditLogs"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/notifications"),
            name: that.$t("search.allNotifications"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/activities"),
            name: that.$t("search.allActivities"),
        },

        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chat"),
            name: that.$t("message.home"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/tasks"),
            name: that.$t("search.tasks"),
            keywords: [
                that.$t("auto.editTasks"),
                that.$t("search.todo"),
                that.$t("search.workFlow"),
                "Todo",
                "Kanban",
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/triggers"),
            name: [that.$t("message.triggers"), that.$t("search.smart")],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chat?tab=teamChat"),
            name: that.$t("search.teamChat"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => openNotificationSettings(),
            name: that.$t("search.soundSettings"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/whatsapp-business-api"),
            name: [that.$t("search.integration.wpBusinessAPI"), "wp", "what"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/instagram"),
            name: that.$t("search.integration.instagram"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/instagram/users"),
            name: that.$t("search.integration.instagramContactList"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/mail"),
            name: that.$t("search.integration.mail"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/stories"),
            name: that.$t("search.chatbot"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/training"),
            name: that.$t("search.chatbotTraining"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/user-segments"),
            name: that.$t("search.chatbotUserSegments"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/integrations"),
            name: that.$t("search.chatbotIntegration"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/entities"),
            name: that.$t("search.chatbotEntities"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/integrations/webhook"),
            name: that.$t("search.chatbotIntegrationWebHook"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/archive"),
            name: that.$t("search.chatbotArchive"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/ai/templates"),
            name: that.$t("search.chatbotTemplatesAI"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/templates"),
            name: that.$t("search.chatbotTemplates"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/overall"),
            name: that.$t("search.chatbotReportsOverall"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/all-chats"),
            name: that.$t("search.chatbotReportsAllChats"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/rating-distribution"),
            name: that.$t("search.chatbotReportsRatingDistribution"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/paid-chats"),
            name: that.$t("search.chatbotReportsPaidChats"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/busiest-period"),
            name: that.$t("search.chatbotReportsBusiestPeriod"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/all-messages"),
            name: that.$t("search.chatbotTemplatesAllMessages"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/avarage-messages"),
            name: that.$t("search.chatbotTemplatesAvarage"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/popularity"),
            name: that.$t("search.chatbotTemplatesPopularity"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/reports/all-users?created=true"),
            name: that.$t("search.chatbotTemplatesAllUser"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/ticket"),
            name: that.$t("search.ticket"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/archives"),
            name: that.$t("search.archives"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/visitors?tab=tags"),
            name: that.$t("search.tags"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("roles"),
            name: that.$t("search.roles"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("company-users"),
            name: that.$t("search.users"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("departments"),
            name: that.$t("search.subjects"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("templates"),
            name: that.$t("search.contents"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("system-messages"),
            name: that.$t("search.welcomeMessages"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/catalog"),
            name: that.$t("search.catalog"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("forbidden-inputs"),
            name: that.$t("search.bannedWords"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/visitors?tab=banned-visitors"),
            name: that.$t("search.bannedVisitors"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/supsis-app"),
            name: that.$t("search.application"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations"),
            name: that.$t("search.integrations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/mails"),
            name: that.$t("search.mails"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/visitors"),
            name: that.$t("search.visitors"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webhook"),
            name: that.$t("search.integrationsWebhook"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("billing"),
            name: that.$t("search.billing"),
            keywords: [
                that.$t("billing.paymentMethod"),
                that.$t("billing.invoice"),
                that.$t("billing.changeCancelPlan"),
                that.$t("billing.creditCard"),
                that.$t("billing.futureInvoice"),
                that.$t("billing.pastInvoices"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/report-new"),
            name: that.$t("search.reportNew"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/drive"),
            name: "Drive",
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webphone/redsantral"),
            name: "Santral",
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/voice-agent"),
            name: "AI Santral",
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations"),
            name: that.$t("automation.automations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/tables"),
            name: that.$t("tables.tables"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/form?type=list"),
            name: that.$t("form.forms"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/report-new"),
            name: that.$t("report.reports"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/visitors?page=1&perPage=10"),
            name: that.$t("ticimax.members"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/ticket"),
            name: that.$t("ticket.tickets"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/stories?action=create"),
            name: that.$t("search.chatbotStory"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/entities/new"),
            name: that.$t("search.chatbotEntities"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/user-segments?action=create"),
            name: that.$t("search.chatbotUserSegments"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("company-users", "create"),
            name: that.$t("search.users"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("roles", "create"),
            name: that.$t("search.roles"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("departments", "create"),
            name: that.$t("search.subjects"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("system-messages", "create"),
            name: that.$t("search.welcomeMessages"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("forbidden-inputs", "create"),
            name: that.$t("search.bannedWords"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/visitors?tab=tags&action=create"),
            name: that.$t("search.tags"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/triggers?action=create"),
            name: that.$t("message.triggers"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/mails?action=create"),
            name: that.$t("search.mails"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("company"),
            name: [that.$t("search.settings.settings")],
            keywords: [
                that.$t("message.organizationName"),
                that.$t("message.companySlogan"),
                that.$t("message.organizationLogo"),
                "Chatbot Name",
                "Chatbot Logo",
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("features"),
            name: that.$t("search.settings.features"),
            keywords: [
                that.$t("message.selectTopic"),
                that.$t("message.queueNumberVisibleFeature"),
                that.$t("message.bannedWordRestrict"),
                that.$t("message.ticketShow"),
                that.$t("message.audioCallEnabled"),
                that.$t("message.videoCallEnabled"),
                that.$t("message.agentVoiceRecordEnabled"),
                that.$t("message.visitorVoiceRecordEnabled"),
                that.$t("message.autoCallTransfer"),
                that.$t("message.privateChatEnabled"),
                that.$t("message.agentFileSendEnabled"),
                that.$t("message.visitorFileSendEnabled"),
                that.$t("message.visitorWriteEmptyChat"),
                that.$t("message.disableAgentSystemMessages"),
                that.$t("message.visitorGDPRDeleteEnabled"),
                that.$t("message.visitorConnectionEventSystemMessageEnabled"),
                that.$t("message.disableAutoTranslate"),
                that.$t("message.visitorAutoLogin"),
                that.$t("message.visitorLocationEnabled"),
                that.$t("message.customerLocationEnabled"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/talk-settings"),
            name: that.$t("search.settings.talkSettings"),
            keywords: [that.$t("message.customerTyping"), that.$t("message.agentTyping")],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("language"),
            name: that.$t("search.settings.languageAndRegion"),
            keywords: [
                that.$t("message.clientDefault"),
                that.$t("message.customerClientDefault"),
                that.$t("settings.timeZoneTitle"),
                that.$t("message.customerClientLanguageDetect"),
                that.$t("message.visitorPreferredLang"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/bubble-settings"),
            name: that.$t("search.settings.bubbleSettings"),
            keywords: [
                that.$t("message.animations"),
                that.$t("message.chatPosition"),
                that.$t("message.autoHideBubble"),
                that.$t("message.hideBubble"),
                that.$t("message.hideBubbleOnMobile"),
                that.$t("message.brandVisibility"),
                that.$t("message.bubbleIcon"),
                that.$t("fastWizard.chatBubbleColor"),
                that.$t("message.inputHeightOfBubble"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/bubble-actions"),
            name: that.$t("search.settings.bubbleActions"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/theme-settings"),
            name: [
                that.$t("search.settings.themeSettings"),
                that.$t("search.theme"),
                that.$t("search.appearance"),
                that.$t("search.color"),
                that.$t("search.background"),
            ],
            keywords: [
                that.$t("settings.visitorNew"),
                that.$t("theme.headerColorSecond"),
                that.$t("theme.headerColorFirst"),
                that.$t("theme.backgroundColorFirst"),
                that.$t("theme.backgroundColorSecond"),
                that.$t("theme.bubbleBackground"),
                that.$t("theme.bubbleText"),
                that.$t("message.bubbleColor"),
                that.$t("theme.bubbleVisitorBackground"),
                that.$t("theme.bubbleVisitorText"),
                that.$t("theme.textColor"),
                that.$t("theme.errorTheme"),
                that.$t("theme.formColor"),
                that.$t("theme.buttonColor"),
                that.$t("theme.chatBotButtonText"),
                that.$t("theme.chatBotButtonColor"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webchat/visitor-login-form"),
            name: that.$t("search.settings.visitorLoginForm"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/visitors?tab=profile-fields"),
            name: that.$t("search.settings.visitorAttribute"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("auto-assign"),
            name: that.$t("search.settings.autoAssign"),
            keywords: [
                that.$t("message.autoCallTransfer"),
                that.$t("message.autoAssignLimit"),
                "Algorithm - Ordered",
                "Algorithm - Random",
                "Algorithm - Round Robin",
                "Algorithm - Round Robin Reverse",
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("timings-settings"),
            name: that.$t("search.settings.chatTimingSettings"),
            keywords: [
                that.$t("message.delayTime"),
                that.$t("message.wasted"),
                that.$t("message.disconnectTime"),
                that.$t("message.inactiveThresholdTime"),
                that.$t("message.inactiveTerminateTime"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("availability"),
            name: that.$t("search.settings.availability"),
            keywords: [
                that.$t("fastWizard.channelAvailability"),
                that.$t("message.offlineMode"),
                that.$t("fastWizard.basedOnTeam"),
                that.$t("fastWizard.customHours"),
            ],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("website-integration"),
            name: that.$t("search.settings.websiteIntegration"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("developer"),
            name: that.$t("search.settings.developer"),
        },
        {
            prefix: PREFIX.NEW,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/calendar/d?action=create"),
            name: that.$t("search.calendar"),
        },

        // --- Eksik Entegrasyonlar ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/messenger"),
            name: [that.$t("search.integration.messenger"), "Messenger", "Facebook"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/telegram-qr"),
            name: [that.$t("search.integration.telegram"), "Telegram"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/whatsapp-v3"),
            name: [that.$t("search.integration.whatsappV3"), "WhatsApp V3"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/waba"),
            name: [that.$t("search.integration.waba"), "WABA"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/meta-leads"),
            name: [that.$t("search.integration.metaLeads"), "Meta", "Facebook Leads"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/linkedin"),
            name: [that.$t("search.integration.linkedin"), "LinkedIn"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/youtube-comments"),
            name: [that.$t("search.integration.youtubeComments"), "YouTube"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/google-business-reviews"),
            name: [that.$t("search.integration.googleBusinessReviews"), "Google Business"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/google-play-reviews"),
            name: [that.$t("search.integration.googlePlayReviews"), "Google Play"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/appstore-reviews"),
            name: [that.$t("search.integration.appstoreReviews"), "App Store", "Apple"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/google-drive"),
            name: [that.$t("search.integration.googleDrive"), "Google Drive"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/instagram-v2"),
            name: [that.$t("search.integration.instagramV2"), "Instagram V2"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/openai"),
            name: [that.$t("search.integration.openai"), "OpenAI", "GPT", "AI"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/openrouter/openai"),
            name: [that.$t("search.integration.openrouter"), "OpenRouter", "AI"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/ideasoft"),
            name: [that.$t("search.integration.ideasoft"), "Ideasoft"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/bitrix24"),
            name: [that.$t("search.integration.bitrix24"), "Bitrix24", "CRM"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/zoho"),
            name: [that.$t("search.integration.zoho"), "Zoho", "CRM"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/ticimax"),
            name: [that.$t("search.integration.ticimax"), "Ticimax"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/ticimax-v2"),
            name: [that.$t("search.integration.ticimaxV2"), "Ticimax V2"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/teamgram"),
            name: [that.$t("search.integration.teamgram"), "TeamGram", "CRM"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/holidayplus"),
            name: [that.$t("search.integration.holidayplus"), "HolidayPlus"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/trendyol"),
            name: [that.$t("search.integration.trendyol"), "Trendyol"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/t-soft"),
            name: [that.$t("search.integration.tSoft"), "T-Soft"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/ikas"),
            name: [that.$t("search.integration.ikas"), "Ikas"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/sms/postacell"),
            name: [that.$t("search.integration.postacell"), "PostaCell", "SMS"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webphone/telnyx"),
            name: [that.$t("search.integration.telnyx"), "Telnyx"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webphone/netgsm"),
            name: [that.$t("search.integration.netgsm"), "NetGSM"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webtabs"),
            name: [that.$t("search.integration.webtabs"), "Web Tabs"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/webapps"),
            name: [that.$t("search.integration.webapps"), "Web Apps"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/whatsapp"),
            name: [that.$t("search.integration.whatsapp"), "WhatsApp"],
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/whatsapp/contact-list"),
            name: that.$t("search.integration.whatsappContactList"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/whatsapp/broadcast/customer-groups"),
            name: that.$t("search.integration.wpBCCustomerGroups"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/integrations/whatsapp/broadcast/message-templates"),
            name: that.$t("search.integration.wpBCTemplates"),
        },

        // --- Eksik Ayarlar ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("wallet"),
            name: that.$t("search.settings.wallet"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("access-control"),
            name: that.$t("search.settings.accessControl"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("sessions"),
            name: that.$t("search.settings.sessions"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("contact-module-rules"),
            name: that.$t("search.settings.contactModuleRules"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => settingPageChange("task-module-rules"),
            name: that.$t("search.settings.taskModuleRules"),
        },

        // --- Eksik Chatbot Alt Sayfaları ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/block-market"),
            name: that.$t("search.chatbotBlockMarket"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/chatbot/sandbox"),
            name: that.$t("search.chatbotSandbox"),
        },

        // --- Eksik Otomasyon Alt Sayfaları ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/all-automations"),
            name: that.$t("search.allAutomations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/scheduled-automations"),
            name: that.$t("search.scheduledAutomations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/event-based-automations"),
            name: that.$t("search.eventBasedAutomations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/button-automations"),
            name: that.$t("search.buttonAutomations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/webhook-automations"),
            name: that.$t("search.webhookAutomations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/automation-insights"),
            name: that.$t("search.automationInsights"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/automations/automation-sandbox"),
            name: that.$t("search.automationSandbox"),
        },

        // --- Eksik Mail Alt Sayfaları ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/mails/inbox"),
            name: that.$t("search.mailInbox"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/mails/templates"),
            name: that.$t("search.mailTemplates"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/mails/broadcast"),
            name: that.$t("search.mailBroadcast"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/mails/customer-groups"),
            name: that.$t("search.mailCustomerGroups"),
        },

        // --- Eksik Takvim / Rezervasyon Sayfaları ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/reservation"),
            name: that.$t("search.reservation"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/reservation/landing-page"),
            name: that.$t("search.reservationLandingPage"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/reservation/programs"),
            name: that.$t("search.reservationPrograms"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/reservation/automations"),
            name: that.$t("search.reservationAutomations"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/calendar/events"),
            name: that.$t("search.calendarEvents"),
        },
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/calendar/reservations"),
            name: that.$t("search.calendarReservations"),
        },

        // --- Eksik Profil ---
        {
            prefix: PREFIX.JUMP,
            type: TYPES.NAVIGATOR,
            action: () => that.$router.push("/profile"),
            name: that.$t("search.profile"),
        },
    ];
};
